import { SVGProps } from 'react';

function EditPenIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_2414_299" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2414_299)">
        <path d="M2 19V15.6154L15.1904 2.43078C15.3416 2.29343 15.5086 2.18729 15.6913 2.11237C15.874 2.03746 16.0656 2 16.2661 2C16.4666 2 16.6608 2.03558 16.8488 2.10675C17.0368 2.1779 17.2032 2.29103 17.348 2.44615L18.5692 3.68268C18.7243 3.82754 18.8349 3.99424 18.9009 4.18278C18.9669 4.37129 19 4.55981 19 4.74833C19 4.94941 18.9656 5.14131 18.8969 5.32403C18.8283 5.50676 18.719 5.67373 18.5692 5.82495L5.38458 19H2ZM16.0519 6.1942L17.5 4.75573L16.2442 3.49998L14.8058 4.94805L16.0519 6.1942Z" fill="#F99107" />
      </g>
    </svg>
  );
}

export default EditPenIcon;
